import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import i18n from './i18n'

// Lokal gehostete Schrift (SIL Open Font License) – nur die benötigten Schnitte
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
// Lokal gehostete Icons: Tabler Icons (MIT) – Outline-Webfont; gefüllte Glyphen siehe src/styles/tabler-filled.scss
import '@tabler/icons-webfont/dist/tabler-icons.min.css'
import '../styles/tabler-filled.scss'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    // Interne Vuetify-Icons (Checkbox, Radio, Sortierung, Paginierung, Alerts …) auf Tabler abbilden.
    // Schreibweise "ti-name" = Outline-Font, "tif ti-name" = Filled-Font.
    values: {
      complete: 'ti-check',
      cancel: 'ti-circle-x',
      close: 'ti-x',
      delete: 'ti-circle-x',
      clear: 'ti-x',
      success: 'ti-circle-check',
      info: 'ti-info-circle',
      warning: 'ti-alert-triangle',
      error: 'ti-alert-circle',
      prev: 'ti-chevron-left',
      next: 'ti-chevron-right',
      checkboxOn: 'tif ti-square-check',
      checkboxOff: 'ti-square',
      checkboxIndeterminate: 'tif ti-square-minus',
      delimiter: 'tif ti-circle',
      sort: 'ti-arrow-up',
      expand: 'ti-chevron-down',
      menu: 'ti-menu-2',
      subgroup: 'ti-caret-down',
      dropdown: 'ti-chevron-down',
      radioOn: 'tif ti-circle-dot',
      radioOff: 'ti-circle',
      edit: 'ti-pencil',
      ratingEmpty: 'ti-star',
      ratingFull: 'tif ti-star',
      ratingHalf: 'tif ti-star-half',
      loading: 'ti-loader-2',
      first: 'ti-chevrons-left',
      last: 'ti-chevrons-right',
      unfold: 'ti-arrows-sort',
      file: 'ti-paperclip',
      plus: 'ti-plus',
      minus: 'ti-minus'
    }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        // Corporate Identity: Blau und Rot bleiben exakt erhalten
        primary: '#113e7c',
        accent: '#e3000a',
        secondary: '#1f2937',
        // Statusfarben (Fehler bewusst dunkler als das Markenrot)
        error: '#b3261e',
        success: '#2e7d32',
        warning: '#ed6c02',
        info: '#0b63ce',
        anchor: '#113e7c'
      }
    }
  }
})
